import { Link } from '@inertiajs/inertia-vue';
import moment from 'moment';
import BirthdayField from '@/funnels/components/form/birthdayField/BirthdayField';
import { NAME_VALIDATION } from '../../regex/name';
import { SPAIN_PHONE_PREFIX_CODE } from '@/constants/phone';
import { MIN_INCOME } from '@/constants/monetary';

const DNI = 'dni';
const NIE = 'nie';

export default {
  props: {
    backUrl: {
      type: String,
      required: true,
    },
    provinceOptions: {
      type: Array,
      required: true,
    },
    occupancyOptions: {
      type: Object,
      required: false,
    },
    employmentOptions: {
      type: Object,
      required: false,
    },
  },
  computed: {
    nameField() {
      return {
        name: 'name',
        type: 'text',
        label: 'Nombre',
        placeholder: 'Tu nombre',
        validation: ['required', ['matches', 'min:2', NAME_VALIDATION]],
        'validation-messages': {
          matches: 'Contiene carácteres incorrectos.',
          required: 'El nombre es obligatorio.',
          min: 'Introduce un nombre de al menos 2 letras.',
        },
      };
    },
    surnameField() {
      return {
        name: 'surname',
        type: 'text',
        label: 'Apellido',
        placeholder: 'Tu apellido',
        validation: ['required', ['matches', 'min:2', NAME_VALIDATION]],
        'validation-messages': {
          matches: 'Contiene carácteres incorrectos.',
          required: 'El apellido es obligatorio.',
          min: 'Introduce un apellido de al menos 2 letras.',
        },
      };
    },
    phoneField() {
      return {
        component: 'div',
        class: 'formulate-input phone-input',
        children: [
          {
            help: 'Teléfono',
            helpPosition: 'before',
            name: 'phone',
            type: 'phone',
            noExample: true,
            showCodeOnList: true,
            noFlags: true,
            borderRadius: 12,
            translations: {
              phoneNumberLabel: 'Número de teléfono',
              countrySelectorLabel: 'código de país',
            },
            defaultCountryCode: SPAIN_PHONE_PREFIX_CODE,
            validation: 'required|phoneIsValid',
            'validation-messages': {
              required: 'El teléfono es obligatorio.',
              phoneIsValid: 'El número introducido es inválido.',
            },
          },
        ],
      };
    },
    emailField() {
      return {
        name: 'email',
        type: 'email',
        label: 'Correo electrónico',
        placeholder: 'Correo electrónico',
        validation: 'required|email',
        'validation-messages': {
          required: 'El mail es obligatorio.',
          email: 'El formato no es correcto.',
        },
      };
    },
    priceField() {
      return {
        name: 'form_price',
        type: 'currency',
        label: '¿Cuál es el valor de la vivienda?',
        placeholder: '0 €',
        showPlaceholder: true,
        currency: 'EUR',
        locale: 'es',
        inputmode: 'numeric',
        validation: 'required|number|min:35000',
        'validation-messages': {
          required: 'Indícanos el valor de la vivienda.',
          number: 'El valor introducido debería ser númerico.',
          min: 'Los bancos no suelen conceder financiación a operaciones menores de 35.000 €.',
        },
      };
    },
    provinceField() {
      return {
        name: 'province_id',
        type: 'triotecaSelect',
        class: 'input-select',
        options: this.provinceOptions,
        label: 'Provincia',
        placeholder: 'Selecciona una opción',
        validation: 'required',
        'validation-messages': {
          required: 'Selecciona una provincia',
        },
      };
    },
    occupancyField() {
      return {
        name: 'occupancy',
        type: 'triotecaSelect',
        class: 'input-select',
        options: this.occupancyOptions,
        label: '¿Cuál es el uso de la vivienda?',
        placeholder: 'Selecciona una opción',
        validation: 'required',
        'validation-messages': {
          required: 'Selecciona el uso',
        },
      };
    },
    initialSignatureDateField() {
      return {
        name: 'initialSignatureDate',
        type: 'triotecaDatepicker',
        label: '¿Cuándo firmaste la hipoteca?',
        'minimum-view': 'month',
        'initial-view': 'year',
        validation: `required|date|before:${moment().format('MM/DD/YYYY')}`,
        'validation-messages': {
          required: 'Selecciona mes/año',
          date: 'La fecha es incorrecta',
          before: 'La fecha debe ser anterior a hoy',
        },
      };
    },
    initialYearsField() {
      return {
        name: 'years',
        type: 'number',
        label: '¿A cuántos años firmaste?',
        value: 30,
        validation: 'required|number|min:10|max:30',
        'validation-messages': {
          required: 'Indícanos el plazo inicial',
          min: 'El valor no puede ser inferior a 10 años',
          max: 'El valor no puede  ser superior a 30 años',
        },
      };
    },
    amountBorrowedField() {
      return {
        name: 'amount_borrowed',
        type: 'currency',
        label: '¿Cuánto te falta por pagar?',
        validation: 'required|number|min:0',
        currency: 'EUR',
        locale: 'es',
        inputmode: 'numeric',
        validation: 'required|min:50000|max:2000000',
        'validation-messages': {
          required: 'El campo es obligatorio.',
          number: 'El valor introducido debería ser númerico.',
          min: 'El valor no puede ser inferior a 50.000 €',
          max: 'El valor no puede  ser superior a 2.000.000 €',
        },
      };
    },
    terms() {
      return {
        component: 'div',
        class: 'formulate-input formulate-input--terms col-span-2',
        children: [
          {
            name: 'termsConsent',
            type: 'customCheckbox',
            validation: 'accepted',
            'validation-messages': {
              accepted: 'El campo es obligatorio.',
            },
            settings: {
              label: 'He leído y acepto la ',
              link: {
                href: 'https://trioteca.com/legal/politica-de-privacidad',
                text: 'Política de Privacidad.',
              },
              required: true,
            },
          },
        ],
      };
    },
    inform() {
      return {
        component: 'div',
        class: 'formulate-input col-span-2',
        children: [
          {
            name: 'isNewsletterSubscriber',
            type: 'customCheckbox',
            settings: {
              label: 'Acepto recibir comunicaciones con fines comerciales que puedan ser de mi interés.',
            },
          },
        ],
      };
    },
    backButton() {
      return {
        component: Link,
        href: this.backUrl,
        children: 'Volver',
        '@click': this.handleBack,
      };
    },
    submitButton() {
      return {
        type: 'submit',
        name: 'submit',
        label: 'Finalizar',
      };
    },
    normalButtons() {
      return {
        component: 'div',
        class: 'form-buttons form-buttons--invisible',
        id: 'form-buttons',
        children: [this.backButton, this.submitButton],
      };
    },
    fixedButtons() {
      return {
        component: 'div',
        class: 'form-buttons fixed-form-buttons',
        id: 'fixed-form-buttons',
        children: [this.backButton, this.submitButton],
      };
    },
    buttons() {
      return {
        component: 'div',
        children: [this.normalButtons, this.fixedButtons],
      };
    },
  },
  methods: {
    handleBack() {
      this.$emit('backButton');
    },
  },
};
